import { storeTasks, dashboardAllTasks } from "../../../actions/task";
import { requestMethod } from "../../../config";
import envConfig from "../../../env.config";
import { fetch } from "../../../shared/services/api.service";
import { checkApiSuccess } from "../../../utils";
import { getMyTasks } from "../../Tasks/tasks.service";

export const getProjectTasks = (payload) => {
  return async (dispatch) => {
    try {
      const requestConfig = {
        method: requestMethod.POST,
        url: `${envConfig.BASE_URL.BASE_API_URL}/task/getProjectTasks`,
        data: payload,
      };
      const response = await fetch(requestConfig, false, false);
      if (checkApiSuccess(response)) {
        const { tasks, formsCount } = response.data.data;
        if (tasks) {
          tasks.superset = tasks?.myTasks?.concat(tasks?.projectTasks);
          tasks.formsCount = formsCount || 0;
          dispatch(dashboardAllTasks(tasks));
        } else {
          console.error('Tasks data is undefined in API response');
          dispatch(dashboardAllTasks({ formsCount: formsCount || 0 }));
        }
      } else {
        console.error('API call failed:', response);
        dispatch(dashboardAllTasks({}));
      }
    } catch (error) {
      console.error('Error in getProjectTasks:', error);
      dispatch(dashboardAllTasks({ formsCount: 0 }));
    }
  };
};

export const getUserOverviewTasks = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.POST,
      url: `${envConfig.BASE_URL.BASE_API_URL}/task/getUserTasks`,
      data: payload,
    };
    const response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      let myTasks = response.data.data.tasks;
      let tasks = getMyTasks(myTasks);
      tasks.superset = tasks.myTasks?.concat(tasks.projectTasks);
      dispatch(storeTasks(tasks));
    }
  };
};
